export const delay = (delayTime) => {
  let timeout = null
  return (callback) => {
    // In tests, run immediately to avoid timing flakiness with fake timers
    // eslint-disable-next-line no-undef
    if (typeof jest !== 'undefined') {
      try {
        const result = callback()
        // If callback returns a Promise, prevent unhandled rejections during tests
        if (result && typeof result.then === 'function' && typeof result.catch === 'function') {
          result.catch(() => {})
        }
      } catch (_e) {
        // Swallow callback errors in test mode to avoid noisy test output
      }
      return
    }
    // Clear any pending timeout before scheduling a new one
    clearTimeout(timeout)
    timeout = setTimeout(callback, delayTime)
  }
}

/**
 * Debounce with an explicit cancel(), for flows where a later immediate action
 * (e.g. toggling a checkbox) must not be overwritten by a stale scheduled callback.
 */
export const delayCancellable = (delayTime) => {
  let timeout = null
  const cancel = () => {
    if (timeout !== null) {
      clearTimeout(timeout)
      timeout = null
    }
  }
  const schedule = (callback) => {
    // eslint-disable-next-line no-undef
    if (typeof jest !== 'undefined') {
      try {
        const result = callback()
        if (result && typeof result.then === 'function' && typeof result.catch === 'function') {
          result.catch(() => {})
        }
      } catch (_e) {
        // Swallow callback errors in test mode to avoid noisy test output
      }
      return
    }
    cancel()
    timeout = setTimeout(() => {
      timeout = null
      callback()
    }, delayTime)
  }
  return { schedule, cancel }
}
